import React from "react"

export default function SiteSettingsEmailTab(props: {
  emailEnabled: boolean
  setEmailEnabled: (v: boolean) => void
  resendApiKey: string
  setResendApiKey: (v: string) => void
}) {
  const { emailEnabled, setEmailEnabled, resendApiKey, setResendApiKey } = props

  return (
    <div className="mb-8">
      <div className="bg-gray-950 border border-gray-800 p-6">
        <div className="flex items-start justify-between gap-6 mb-6">
          <div className="flex-1">
            <h3 className="text-xl font-light tracking-wide text-gray-100 mb-2">郵件系統設定</h3>
            <p className="text-sm text-gray-400 mb-3">控制網站是否發送 Email 通知（訂單確認、歡迎郵件等）</p>
          </div>

          <div className="flex flex-col items-end gap-2">
            <button
              onClick={() => setEmailEnabled(!emailEnabled)}
              className={`relative inline-flex h-8 w-16 items-center rounded-full transition-colors ${
                emailEnabled ? "bg-green-600" : "bg-gray-700"
              }`}
              aria-label="切換郵件系統"
            >
              <span
                className={`inline-block h-6 w-6 transform rounded-full bg-white transition-transform ${
                  emailEnabled ? "translate-x-9" : "translate-x-1"
                }`}
              />
            </button>
            <span className={`text-sm font-medium ${emailEnabled ? "text-green-400" : "text-gray-500"}`}>
              {emailEnabled ? "已啟用" : "已停用"}
            </span>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 space-y-6">
          <div>
            <label className="block text-sm text-gray-400 mb-2">Resend API Key（選填）</label>
            <input
              type="password"
              value={resendApiKey}
              onChange={(e) => setResendApiKey(e.target.value)}
              placeholder="如需更換郵件服務供應商可填寫"
              className="w-full px-4 py-3 bg-gray-900 border border-gray-700 text-gray-100 focus:outline-none focus:border-blue-500"
            />
            <div className="text-xs text-gray-500 mt-2">此欄位為備用功能，目前郵件服務已配置完成，無需填寫</div>
          </div>

          <div className="bg-yellow-950 bg-opacity-30 border border-yellow-800 p-4 rounded">
            <div className="text-xs text-yellow-300 space-y-1">
              <div>• 停用後，所有郵件通知將不會發送</div>
              <div>• 功能邏輯仍正常執行，僅郵件通知受影響</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
